import React from 'react';
import clsx from 'clsx';
import { RichText as LexicalRichText } from '@payloadcms/richtext-lexical/react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';

const RichText = ({ content, className }: { content: SerializedEditorState | null, className?: string }) => {
  if (!content) {
    return null;
  };

  return (
    <div className={clsx('copy-text', className)}>
      <LexicalRichText data={content} />
    </div>
  );
};

export  { RichText };

